import 'rxjs/add/observable/of';
import 'rxjs/add/observable/from';
import 'rxjs/add/observable/forkJoin';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/mergeMap';
import 'rxjs/add/operator/catch';
import { merge } from 'icepick';
import { Observable } from 'rxjs/Observable';
import log from '@atlassian/jira-common-util-logging/src/log';
import loadAdditionalDataService, {
	type AdditionalBoardData,
} from '../../services/load-additional-data';
import loadEditModelService, { type EditModel } from '../../services/load-edit-model';
import { makeServiceContext } from '../../services/service-context';
import {
	LOAD_CONFIG_DATA_REQUEST,
	setConfigData,
	loadConfigDataFailure,
	loadConfigDataSuccess,
} from '../../state/actions/app';
import { setColumns } from '../../state/actions/columns';
import type { MiddlewareAPI, ActionsObservable } from '../../state/types';

export const loadConfigDataEpic = (action$: ActionsObservable, store: MiddlewareAPI) =>
	action$
		.ofType(LOAD_CONFIG_DATA_REQUEST)
		.mergeMap(() =>
			Observable.forkJoin(
				loadEditModelService(makeServiceContext(store.getState())),
				loadAdditionalDataService(store),
			),
		)
		.mergeMap(
			([{ entities, config, columns }, additionalBoardData]: [EditModel, AdditionalBoardData]) =>
				Observable.from([
					setConfigData(merge({ entities, config }, additionalBoardData)),
					loadConfigDataSuccess(),
					setColumns(columns),
				]),
		)
		.catch((error) => {
			log.safeErrorWithoutCustomerData(
				'backlog.load-config-data.failure',
				'Failed to load config data',
				error,
			);
			return Observable.of(loadConfigDataFailure());
		});
